import React from "react";
import "./style.css";
import { linkedin, github } from "../../../assets/icons";

const SocialConnect = (props) => {
  return (
    <div
      className={
        navigator.userAgent.match(/samsung/i)
          ? "socialConnectD ptb"
          : "socialConnect ptb"
      }
      style={props.style}
    >
      <span className="textColor font-12 mlr-10">Connect with me on</span>
      <a className="socialLink" href="http://linkedin.com/in/rashid-ahamed">
        <img src={linkedin} alt="" loading="lazy" />
      </a>
      <a className="socialLink" href="https://github.com/rashidRizvi98">
        <img src={github} alt="" loading="lazy" />
      </a>
    </div>
  );
};

export default SocialConnect;
